import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getJumpUrlHost } from '@src/utils/index';

const Global = ({ allMarket }) => {
    const stockNameList = [
        '美元指数',
        '标普500指数',
        '道琼斯工业平均指数',
        '上证指数',
        '香港恒生指数',
        '现货黄金',
        '现货白银',
        'WTI原油',
        '布伦特油',
        '离岸人民币',
    ];
    const stockList = allMarket.filter(item => stockNameList.includes(item.name));

    // stockList数据按照stockNameList内容进行排序
    stockList.sort((a, b) => {
        return stockNameList.indexOf(a.name) - stockNameList.indexOf(b.name);
    });

    return (
        <div className={styles.global}>
            <div className={styles.globalContentHd}>全球市场</div>
            <div className={styles.globalContentBd}>
                {stockList.map((item, index) => {
                    // 判断涨跌
                    let statusFlag = item.rangePercent.includes('-') ? 'down' : 'up';
                    const statusClassList = {
                        down: styles.globalContentMarketItemGreen,
                        up: styles.globalContentMarketItemRed,
                        flat: styles.globalContentMarketItemGray,
                    };

                    statusFlag = item.rangePercent.includes('--') ? 'flat' : statusFlag;

                    return (
                        <a
                            href={`${getJumpUrlHost('pc')}/marketDetail?quoteCode=${encodeURIComponent(
                                item.quoteCode,
                            )}`}
                            key={index}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${styles.globalContentMarketItem} ${statusClassList[statusFlag]}`}>
                            <div className={styles.globalContentMarketName}>{item.name}</div>
                            <div className={styles.globalContentMarketPrice}>{item.tradePrice}</div>
                            <div className={styles.globalContentMarketRange}>
                                <span>{statusFlag === 'up' ? `+${item.range}` : item.range}</span>
                                <span>{statusFlag === 'up' ? `+${item.rangePercent}` : item.rangePercent}</span>
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

Global.propTypes = {
    allMarket: PropTypes.array,
};

export default errorBoundary(Global);
